import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const SegmentsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "SegmentsComponent" */ "@circle-react/components/SettingsApp/Segments"
    ),
);

export const SegmentsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <SegmentsComponent />
  </Suspense>
);
